/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgCheckCircleFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.7527 8.25269C15.1823 7.82312 15.1823 7.12663 14.7527 6.69706C14.3231 6.26748 13.6266 6.26748 13.1971 6.69706L8.67157 11.2225L6.97452 9.52549C6.54494 9.09591 5.84846 9.09591 5.41888 9.52549C4.9893 9.95506 4.9893 10.6515 5.41888 11.0811L7.89375 13.556C8.32333 13.9856 9.01981 13.9856 9.44939 13.556L14.7527 8.25269Z'
    />
  </svg>
)
export default SvgCheckCircleFilled
